const state = {
    audioPlayerState: false,
    audioToRender: null,
    audioName: null,
    audioPlayerPosition: {
        left: '50%',
        top: '85%'
    },
};
const getters = {
    getAudioPlayerState: (state) => state.audioPlayerState,
    getAudioData: (state) => ({ audio: state.audioToRender, name: state.audioName }),
    getAudioPlayerPosition: (state) => state.audioPlayerPosition,
};
const mutations = {
    setAudioData(state, data) {
        if (data) {
            state.audioToRender = data?.audio || null;
            state.audioName = data?.name || null;
            state.audioPlayerState = !!data;
            return;
        }
        state.audioName = null;
        state.audioToRender = null;
        state.audioPlayerState = !!data;
    },
    setAudioPlayerPosition(state, data) {
        state.audioPlayerPosition = data || { left: 0, top: 0 };
    },
};
const actions = {
    setAudioData({ commit }, payload) {
        commit('setAudioData', payload);
    },
    setAudioPlayerPosition({ commit }, payload) {
        commit('setAudioPlayerPosition', payload);
    },
};
export default {
    state,
    getters,
    mutations,
    actions
};
